export default (state, { payload }) => ({
  ...state,
  loadingDataOnPageLoad: payload
});
